export default __webpack_public_path__ + "static/media/Office_filled.9524c8e3.svg";